/**
 *  This Files contains all switches in new run page that can easily
 *  Turn on/off a feature
 *
 */
export const ENABLE_DSNONLINESTATUS = true;
